import React from 'react';
import styled from 'styled-components';

import LoadingBar from 'components/LoadingBar';

const SLoadingContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const LoadingContent = () => (
  <SLoadingContentContainer>
    <div>Uploading project to environment. Please wait…</div>
    <LoadingBar color="blue" />
  </SLoadingContentContainer>
);

export default LoadingContent;
